<template>
    <tfoot class="rosterLocationFooter" v-if="cropLocationVarietyRosters">
        <tr>
            <td class="footerFirstColumn font-weight-bold info lighten-4">Total {{ showActuals ? 'Forecast' : '' }} Volume</td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(0) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(1) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(2) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(3) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(4) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(5) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(6) | thousandsSeparators}}{{uom}}</div></td>
            <td v-if="showPreviousSunday" colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalVolumeForDay(7) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="footerLastColumn3 info lighten-4"><div class="font-weight-bold" >{{getGrandTotalVolume() | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="footerLastColumn2 info lighten-4"><div class="font-weight-bold" v-html="getGrandTotalVarToForecast()"></div></td>
            <td colspan="1" class="footerLastColumn1 info lighten-4"></td>
        </tr>
        <tr v-if="showActuals">
            <td class="footerFirstColumn font-weight-bold info lighten-4">Actuals Volume</td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(0) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(1) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(2) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(3) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(4) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(5) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(6) | thousandsSeparators}}{{uom}}</div></td>
            <td v-if="showPreviousSunday" colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getTotalActualVolumeForDay(7) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="footerLastColumn3 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn2 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn1 info lighten-4"></td>
        </tr>
        <tr>
            <td class="footerFirstColumn font-weight-bold info lighten-4">Rostered Teams</td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(0)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(1)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(2)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(3)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(4)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(5)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(6)}}</div></td>
            <td v-if="showPreviousSunday" colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredTeamForDay(7)}}</div></td>
            <td colspan="1" class="footerLastColumn3 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn2 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn1 info lighten-4"></td>
        </tr>
        <tr>
            <td class="footerFirstColumn font-weight-bold info lighten-4">Rostered Locations</td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(0)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(1)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(2)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(3)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(4)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(5)}}</div></td>
            <td colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(6)}}</div></td>
            <td v-if="showPreviousSunday" colspan="2" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getRosteredLocationForDay(7)}}</div></td>
            <td colspan="1" class="footerLastColumn3 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn2 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn1 info lighten-4"></td>
        </tr>
        <tr>
            <td class="footerFirstColumn font-weight-bold info lighten-4">Vol/Loc Under Spray</td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(0) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(0)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(1) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(1)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(2) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(2)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(3)}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(3)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(4) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(4)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(5) | thousandsSeparators}}{{uom}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(5)}}</div></td>
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(6) | thousandsSeparators}}{{uom}}</div></td> 
            <td colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(6)}}</div></td>
            <td v-if="showPreviousSunday" colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayVolumeForDay(7) | thousandsSeparators}}{{uom}}</div></td> 
            <td v-if="showPreviousSunday" colspan="1" class="info lighten-4"><div class="font-weight-bold vertical-cell">{{getSprayLocationsForDay(7)}}</div></td>
            <td colspan="1" class="footerLastColumn3 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn2 info lighten-4"></td>
            <td colspan="1" class="footerLastColumn1 info lighten-4"></td>
        </tr>                    
    </tfoot>
</template>

<script>
import RosterUtilService from '@/services/rosterUtilService';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
   
    },
    props: {
        cropLocationVarietyRosters: {
            type: Array,
            required: false
        }
    },
    data(){
        return {
      
        }
    },
    computed: {
        ...mapState("RosterStore", [
            "showPreviousSunday",
            "showActuals",
            "showPreviousSunday"
        ]),
        ...mapGetters("RosterStore", [
            "uom"
        ])
    },
    methods: {
        getTotalActualVolumeForDay(dayIndex) {
            var actualVolume = 0;
            this.cropLocationVarietyRosters.forEach(clvr => {
                var day = clvr.Days[dayIndex];
                if(day != null) {
                    actualVolume = actualVolume + Math.round(parseFloat(day.ActualsDayValue == null ? 0 : day.ActualsDayValue))
                }
            })
            return actualVolume;
        },
        getTotalVolumeForDay(dayIndex) {
            var volume = 0;
            this.cropLocationVarietyRosters.forEach(clvr=> {
                var day = clvr.Days[dayIndex];
                if(day != null) {
                    day.Varieties.forEach(v=> {
                        v.Rosters.forEach(r=> {
                            if(r.RosterValue != null) {
                                volume = volume + parseInt(r.RosterValue);
                            }
                        })
                    })
                }
            })
            
            return Math.round(volume);
        },
        getRosteredTeamForDay(dayIndex) {
            var teamIDs = [];
            this.cropLocationVarietyRosters.forEach(clvr=> {
                var day = clvr.Days[dayIndex];
                if(day != null) {
                    day.Varieties.forEach(v=> {
                        v.Rosters.forEach(r=> {
                            if(r.TeamID != null) {
                                teamIDs.push(r.TeamID);
                            }
                        })
                    })
                }
            })
            return [...new Set(teamIDs)].length;
        },
        getRosteredLocationForDay(dayIndex) {
            var cropLocationIDs = [];
            this.cropLocationVarietyRosters.forEach(clvr=> {
                var day = clvr.Days[dayIndex];
                if(day != null) {
                    if(day.Varieties.some(v=> v.Rosters.some(r=> r.BerriesRosterID >= 0 && r.IsSpray == false && r.TeamID > 0))) {
                        cropLocationIDs.push(day.CropLocationID);
                    }
                   
                }
            })
            return [...new Set(cropLocationIDs)].length;
        },
        getSprayVolumeForDay(dayIndex) {
            var volume = 0;
            this.cropLocationVarietyRosters.forEach(clvr=> {
            var day = clvr.Days[dayIndex];
                if(day != null) {
                    if(day.Varieties.some(v=> v.Rosters.some(r=> r.IsSpray == true) && day.ForecastDayValue != null)) {
                        volume = volume + parseInt(day.ForecastDayValue);
                    }
                   
                }
            })
         
            return Math.round(volume);
        },
        getSprayLocationsForDay(dayIndex) {
            var cropLocationIDs = [];
            this.cropLocationVarietyRosters.forEach(clvr=> {
            var day = clvr.Days[dayIndex];
                if(day != null) {
                    if(day.Varieties.some(v=> v.Rosters.some(r=> r.IsSpray == true))) {
                        cropLocationIDs.push(day.CropLocationID);
                    }
                   
                }
            })
            return [...new Set(cropLocationIDs)].length;
        },
        getGrandTotalVolume() {
            return RosterUtilService.getGrandTotalVolume(this.cropLocationVarietyRosters);
        },
        getGrandTotalVarToForecast() {
            var grandTotalVolume = RosterUtilService.getGrandTotalVolumeExcludingSpray(this.cropLocationVarietyRosters);
            var grandTotalForecast = 0;

            this.cropLocationVarietyRosters.forEach(clvr => {
                grandTotalForecast += clvr.LocationForecastValue;
            });

            var diff = Math.round(grandTotalVolume - grandTotalForecast);

            if(diff==0) {
                return `<span>${RosterUtilService.formatThousandsSeparators(diff)}${this.uom}</span>`;
            }
            else {
                return `<span class='error--text'>${RosterUtilService.formatThousandsSeparators(diff)}${this.uom}</span>`;
            }
        }
    }
    
}
</script>
<style scoped>
.vertical-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.rosterLocationFooter tr td, tr th {
    position: -webkit-sticky;
    position: sticky;
    background-color: white;
    z-index: 25;
}

.rosterLocationFooter tr {
    border-top: none !important;
}
.rosterLocationFooter tr:nth-child(4) td, .rosterLocationFooter tr:nth-child(4) th {
    bottom: 0px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);

}

.rosterLocationFooter tr:nth-child(3) td, .rosterLocationFooter tr:nth-child(3) th {
    bottom: 25px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);

}

.rosterLocationFooter tr:nth-child(2) td, .rosterLocationFooter tr:nth-child(2) th {
    bottom: 50px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);
}

.rosterLocationFooter tr:nth-child(1) td, .rosterLocationFooter tr:nth-child(1) th {
    bottom: 75px;
    height: 25px;
    border-right: 1px solid rgba(0,0,0,0.12);
    outline: 1px solid rgba(0,0,0,0.12);
}

.rosterLocationFooter tr {
    height: 25px;
    border-top: none;
    border-bottom: none;
}
.footerFirstColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 100!important;
    background: white;
}

.footerLastColumn1 {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

.footerLastColumn2 {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

.footerLastColumn3 {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 100!important;
    background: white;
    border: none!important;
    outline:none!important;
    min-width: 100px;
}

</style>